import { Fetcher } from '@this/src/util';
import type { DebugLogEntry } from '../debug/DebugLogContext';

type DebugReportPayload = {
  message: string;
  logs: {
    category: string;
    level: string;
    title: string;
    summary?: string;
    details?: unknown;
  }[];
  proposal_bundles: unknown[];
  reservation_info: unknown;
};

type DebugReportResponse = {
  success: boolean;
};

export const sendDebugReport = async (
  tripId: string,
  message: string,
  logs: DebugLogEntry[],
  proposalBundles: unknown[] = [],
  reservationInfo: unknown = {}
): Promise<DebugReportResponse> => {
  const payload: DebugReportPayload = {
    message,
    logs: logs.map(log => ({
      category: log.category,
      level: log.level,
      title: log.title,
      summary: log.summary,
      details: log.details
    })),
    proposal_bundles: proposalBundles,
    reservation_info: reservationInfo
  };

  return Fetcher.post<DebugReportResponse>(`/trips/${tripId}/ai_debug_reports`, {
    debug_report: payload
  });
};
